module.exports = __webpack_public_path__ + "img/15.64586edb.png";